export const EMAIL_MODAL_LABELS = {
  INVALID_USER_ERROR: 'Name and Email Id are invalid.',
  NO_RECIPIENTS: 'No recipients found for data partner.',
  INVALID_USER_EMAIL: 'Entered Email Id is not correct',
  INVALID_USER_NAME: 'Length of Name field should be less than or equal to 100',
  DUPLICATE_USER_ERROR: 'User with the above email already exists.',
};
